import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

const selectCommon = (state: RootState) => state.common as any;

export const selectLoading = createSelector(selectCommon, (common) => common.loading);
export const selectModalStatus = createSelector(selectCommon, (common) => common.ui.dialog);
